(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceCarrierDetailController', InsuranceCarrierDetailController);

    InsuranceCarrierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InsuranceCarrier', 'Insurance'];

    function InsuranceCarrierDetailController($scope, $rootScope, $stateParams, previousState, entity, InsuranceCarrier, Insurance) {
        var vm = this;

        vm.insuranceCarrier = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:insuranceCarrierUpdate', function(event, result) {
            vm.insuranceCarrier = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
